import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { history } from "../../utils/History";

import Table from "../../components/table";
import TableStatus from "../../components/table/status";
import SearchButton from "../../components/buttons/SearchButton";
import HeaderMenu from "../../components/commons/menu/HeaderMenu";
import DetailButton from "../../components/table/detailButton";
import MenuItem from "@material-ui/core/MenuItem";
import ConfirmationModal from "../../components/modal/ConfirmModal";
import User from '../../store/actions/user/Management'
import SuccessModal from "../../components/response/Success";

import UserModal from "./UserModal";
import useLatestRequest from "../../components/hooks/useLatestRequest";
import {
  pageSizeParam,
  positivePage,
  stringParam,
  useListQueryState,
} from "../../utils/listQueryState";

const USER_QUERY_SCHEMA = {
    page: positivePage,
    length: pageSizeParam,
    search: stringParam(),
};

const Index = ({ loggingIn }) => {
  
    const [dataUser, setDataUser] = useState([]);
    const [dataUserRow, setDataUserRow] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [addUserModal, setAddUserModal] = useState(false);
    const [addSuccessModal, setAddSuccessModal] = useState(false);

    const { state: query, updateQuery } = useListQueryState(USER_QUERY_SCHEMA);
    const { page, length, search: searchText } = query;
    const [totalData, setTotalData] = useState(null);
    const [maxPage, setMaxPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [loadError, setLoadError] = useState(null);
    const { beginRequest, isLatestRequest } = useLatestRequest();

    const dispatch = useDispatch();
    useEffect(() => {
      handleRefresh();
    }, [searchText, page, length]);

    const handleSearch = (value) => {
        updateQuery({ page: 1, search: value?.length > 0 ? value : "" })
    }

    const handleRefresh = () => {
        const requestId = beginRequest();
        setIsLoading(true)
        setLoadError(null)
        new Promise((resolve, reject) => {
            let param = {
                page: page ? page : 1,
                length,
                search_text: searchText,
            }
            dispatch(User.get(param, resolve, reject));
        })
            .then(res => {
                if (!isLatestRequest(requestId)) return;

                setDataUser(res?.data ?? [])
                setTotalData(res?.totalCount ?? 0)
                const nextMaxPage = Math.max(1, Math.ceil((res?.totalCount ?? 0) / length));
                setMaxPage(nextMaxPage)
                if (page > nextMaxPage) updateQuery({ page: nextMaxPage });
            })
            .catch((error) => {
                if (!isLatestRequest(requestId)) return;

                setLoadError(error?.response?.data?.message ?? "Data user gagal dimuat.")
            })
            .finally(() => {
                if (isLatestRequest(requestId)) {
                    setIsLoading(false)
                }
            })
    }

    const showAddUserModal = (data) => {
        setAddUserModal(!addUserModal)
    }

    const showDeleteModal = (data) => {
        setDeleteModal(!deleteModal)
        setDataUserRow(data ? data : [])
    }

    const showAddSuccessModal = (data) => {
        setAddSuccessModal(!addSuccessModal)
      }

    const handleAdd = (param) => {
        const callback = () => {
            handleRefresh()
            setAddUserModal(!addUserModal)
        }

        dispatch(User.addUser(param, callback, showAddSuccessModal));
    };

    const handleDelete = () => {
        const callback = () => {
            handleRefresh()
            setDeleteModal(!deleteModal)
        }

        if (dataUserRow) {
            dispatch(User.deletedUser(dataUserRow, callback))
        }
    }

    const columns = [
        {
        Header: "NO",
        accessor: "no",
        },
        {
        Header: "NAMA",
        accessor: "username",
        },
        {
        Header: "EMAIL",
        accessor: "email",
        },
        {
        Header: "",
        accessor: "actions",
        Cell: ({ row }) => {
            const { original } = row;

            return (
                <DetailButton>
                    <MenuItem onClick={() => showDeleteModal(original)}>
                        <span style={{ fontSize: 14 }}>Hapus</span>
                    </MenuItem>
                </DetailButton>
            );
            
        },
        },
    ];

    return (
        <div className="menu-container">
            <div>
                <HeaderMenu
                    title="Manajemen User"
                    toolbarClassName="page-header-toolbar-split user-toolbar"
                >
                    <SearchButton
                        placeholder="Cari user"
                        value={searchText}
                        toggle={(value) => handleSearch(value)}
                    />
                    <button type="button" className="button mr-2 rounded-button primary button-default" onClick={()=>{showAddUserModal()}}>
                        <i className="fas fa-plus icon-button"></i>{' '} Tambah User
                    </button>
                </HeaderMenu>
            </div>
            <div className="content-container-side">
                <div className="overflow">
                <Table
                    columns={columns}
                    data={dataUser}
                    loading={isLoading}
                    error={loadError}
                    onRetry={handleRefresh}
                    pagination={{
                        page,
                        totalData,
                        maxPage,
                        toggle: (nextPage) => updateQuery({ page: nextPage }),
                        length,
                        onPageSizeChange: (nextLength) => updateQuery({ page: 1, length: nextLength })
                    }}
                />
                </div>
            </div>

            {/* Modal */}
            <UserModal
                show={addUserModal}
                toggle={showAddUserModal}
                action={handleAdd}
                type="add"
            />

            <ConfirmationModal
                show={deleteModal}
                toggle={showDeleteModal}
                confirm={handleDelete}
                data={dataUserRow}
                message = {"Apakah Anda yakin ingin menghapus user ini?"}
                isConfirm = {"Ya, Hapus"}
                icon="info"
                isDelete
            >
            </ConfirmationModal>

            <SuccessModal 
                show={addSuccessModal}
                toggle={showAddSuccessModal}
                title = {"Data Tersimpan"}
                message = {"Aktivasi dan pemulihan password dapat dicek di email yang terdaftar."}
            >
            </SuccessModal>
        </div>

    );
};

export default Index;

